export default "__VITE_ASSET__Czi3Wld8__"